import { createAction } from '@ngrx/store';
import { ReportEntity } from '../entities/ReportEntity';

export const FetchReports = createAction('[REPORTS] fetch reports');

export const SetReports = createAction('[REPORTS] set reports', (list: ReportEntity[]) => ({ list }));
